import React from "react";
import { Route, Routes } from "react-router-dom";
import FrontPage from "./routes/FrontPage/front-Page";
import China from "./routes/china/china";
import World from "./routes/world/world";
import Contact from "./routes/contact/contact"
import ChinaCityDetails from "./components/chinaCityDetails/chinaCityDetails";
import ChinaMarathonDetails from "./components/chinaMarathonDetails/chinaMarathonDetails";
function App() {
  return (
    <div>
      <Routes>
        {/* add FrontPage in the Web */}
        <Route path="/" element={<FrontPage />} />
        <Route path="/China" element={<China />} />
        <Route path="/World" element={<World />} />
        <Route path="/Contact" element={<Contact />} />
        {/* 动态获取城市名，并加入到路径 */}
        <Route path="/china/:cityName" element={<ChinaCityDetails />} />
        {/* 动态获取城市名+马拉松名，并加入到路径 */}
        <Route
          path="/china/:cityName/:marathonName"
          element={<ChinaMarathonDetails />}
        />
      </Routes>
    </div>
  );
}

export default App;
